import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "partner-area mh-partner pb-75" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-xxl-2 col-sm-6 col-md-4",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": 100 * (index + 1)
          }, [
            _createVNode(_component_RouterLink, {
              to: partner.link,
              class: "partner-bg mb-4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: partner.image,
                  alt: partner.alt
                }, null, 8, _hoisted_5)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}